import { render, staticRenderFns } from "./solutions-conversion.vue?vue&type=template&id=674f8ea3&"
import script from "./solutions-conversion.vue?vue&type=script&lang=js&"
export * from "./solutions-conversion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('674f8ea3')) {
      api.createRecord('674f8ea3', component.options)
    } else {
      api.reload('674f8ea3', component.options)
    }
    module.hot.accept("./solutions-conversion.vue?vue&type=template&id=674f8ea3&", function () {
      api.rerender('674f8ea3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/conversion/solutions-conversion.vue"
export default component.exports